import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { OpenFpgaLogo } from '../OpenFpgaLogo';
export function OpenFpgaAdvantageSlide() {
  const stats = [{
    value: '500B+',
    label: 'Inferences Processed'
  }, {
    value: '50K+',
    label: 'Global Developers'
  }, {
    value: '12+',
    label: 'FPGA Providers'
  }, {
    value: '80+',
    label: 'Accelerator Configs'
  }];
  return <SlideLayout slideNumber={17} totalSlides={20} title="Our Platform" data-id="element-441">
      <div className="w-full h-full flex flex-col items-center justify-center text-center" data-id="element-442">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-8" data-id="element-443">
          <div className="flex justify-center mb-5" data-id="element-444">
            <OpenFpgaLogo size="lg" data-id="element-445" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-446">
            The Unified Interface For{' '}
            <span className="text-brand-primary" data-id="element-447">FPGA Inference</span>
          </h2>
          <p className="text-2xl text-brand-muted max-w-3xl mx-auto" data-id="element-448">
            We solve the biggest hurdle to FPGA adoption: complexity. Access the
            world's most powerful programmable hardware through a single,
            standard API.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-8 w-full max-w-4xl" data-id="element-449">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1 + 0.3
        }} data-id="element-450">
              <div className="text-5xl md:text-6xl font-mono font-bold text-white mb-2" data-id="element-451">
                {stat.value}
              </div>
              <div className="text-lg font-bold text-brand-muted uppercase tracking-widest" data-id="element-452">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="text-xl text-brand-muted" data-id="element-453">
          Supported Providers: AMD / Xilinx • Intel / Altera • Lattice •
          Microchip • Achronix • Efinix
        </motion.div>
      </div>
    </SlideLayout>;
}